"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.descriptionsByRange = exports.MAX = exports.MIN = void 0;
const MIN = 500;
exports.MIN = MIN;
const MAX = 10000000;
exports.MAX = MAX;
const descriptionsByRange = [{
  min: 5000,
  max: 30000,
  message: 'Use seu carro como garantia'
}, {
  min: 30001,
  max: 150000,
  message: 'Use seu imóvel ou carro como garantia'
}, {
  min: 150001,
  max: 3000000,
  message: 'Use seu imóvel como garantia'
}];
exports.descriptionsByRange = descriptionsByRange;